import { z } from 'zod'
import { oc } from '@orpc/contract'

export const visitVideoTokenResponseSchema = z.object({
  // Zoom Video SDK session (topic) name — every participant of the encounter joins this room.
  sessionName: z.string(),
  // Video SDK JWT (HS256) minted for the caller as a host-role participant.
  signature: z.string(),
  // Display name to join with (the caller's own name).
  userName: z.string(),
  // Instant the signature expires (ISO-8601); re-request rather than reuse past it.
  expiresAt: z.string(),
  // Caller holds the Medical doctor role — the scribe runs only on the treating physician's client.
  isPhysician: z.boolean(),
  // Caller may use the branded virtual background (doctors and care coordinators).
  virtualBackgroundEligible: z.boolean(),
})
export type VisitVideoTokenResponse = z.infer<typeof visitVideoTokenResponseSchema>

/**
 * Join credentials for an encounter's video visit. Replaces the two Medplum-side calls the
 * web clients make today (session name derivation + `GET /oauth2/call/signature`) so a client
 * never talks to Medplum directly (PD-1543). Providers only; the encounter must be readable
 * by the caller. Consent state is not a gate here — same as the provider portal.
 */
export const visitVideoToken = oc
  .route({ method: 'POST', path: '/v2/visits/{encounterId}/video-token' })
  .input(z.object({ encounterId: z.string().min(1) }))
  .output(visitVideoTokenResponseSchema)
